module.exports = __webpack_public_path__ + "static/media/store_x3.07971c8f.svg";